// 分销
export const distributorSetData = [
  {
    path: "/apply/distribute/10/general",
    name: "分销概况",
    children: []
  },
  // {
  //   path: "/apply/distribute/10/product",
  //   name: "分销商品"
  // },
  {
    path: "/apply/distribute/10/order",
    name: "分销订单",
    children: []
  },
  {
    path: "/apply/distribute/10/withdrawSet/audit",
    name: "提现管理",
    children: [
      {
        path: "/apply/distribute/10/withdrawSet/audit",
        name: "待审核"
      },
      {
        path: "/apply/distribute/10/withdrawSet/remit",
        name: "待打款"
      },
      {
        path: "/apply/distribute/10/withdrawSet/finish",
        name: "已打款"
      },
      {
        path: "/apply/distribute/10/withdrawSet/invalid",
        name: "无效"
      }
    ]
  },
  {
    path: "/apply/distribute/10/distributorSet/people",
    name: "分销商管理",
    children: [
      {
        path: "/apply/distribute/10/distributorSet/people",
        name: "申请列表"
      },
      {
        path: "/apply/distribute/10/distributorSet/list",
        name: "分销商列表"
      }
    ]
  },
  {
    path: "/apply/distribute/10/set/base",
    name: "分销设置",
    children: [
      {
        path: "/apply/distribute/10/set/base",
        name: "基础设置"
      },
      {
        path: "/apply/distribute/10/set/settlemen",
        name: "结算设置"
      },
      {
        path: "/apply/distribute/10/set/share",
        name: "分享设置"
      },
      // {
      //   path: "/apply/distribute/10/set/text",
      //   name: "文字设置",
      // },
      // {
      //   path: "/apply/distribute/10/set/rank",
      //   name: "排行设置",
      // }
    ]
  },
  {
    path: "/apply/distribute/10/grade",
    name: "分销商等级",
    children: []
  }
];
